<template>
	<div :class="selectable ? 'choices-selectable' : ''" class="choices">
		<div :class="activeChoiceIndex === i ? 'choice-container-active' : ''"
		     class="choice-container"
		     v-bind:key="i"
		     v-for="(choice, i) in choices"
		>
			<choice
					:class="'choice-' + i"
					class="choice"
					:format="choice.format"
					:message="choice.message"
					:bookmark="getLetter(i)"
					v-on:click.native="onChoiceClick(i)"
			/>
		</div>
	</div>
</template>

<script>
	import Choice from './choice'

	export default {
		props: {
			selectable: {
				type: Boolean,
				required: false,
				default: false
			},
			choices: {
				type: Array,
				required: true
			},
			value: {},

			instantSelection: {
				type: Boolean,
				required: false,
				default: false
			},
		},
		components: {
			Choice
		},
		data() {
			return {
				activeChoiceIndex: -1
			}
		},
		methods: {
			onChoiceClick(clickedChoiceIndex) {
				if (!this.selectable) {
					return
				}

				if (!this.instantSelection) {
					this.activeChoiceIndex = clickedChoiceIndex
				}

				this.$emit('value', clickedChoiceIndex)
			},
			getLetter(index) {
				switch(index) {
					case 0:
						return 'A';
					case 1:
						return 'B';
					case 2:
						return 'C';
					case 3:
						return 'D';
					case 4:
						return 'E';
					case 5:
						return 'F';
				}
			}
		}
	}
</script>

<style lang="less">
	@import "~@less/variables.less";

	.teacher-container {
		.choices {
			margin: 0 auto;
		}
	}

	.choices {
		margin-top: 20px;

		&.choices-selectable {
			.choice {
				cursor: pointer;
			}
		}

		.choice-container {
			overflow: hidden;
			position: relative;
			margin-bottom: 10px;
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
			justify-content: flex-start;
			align-items: flex-start;
			align-content: stretch;

			&.choice-container-active {
				.choice {
					outline: 4px solid black;
					outline-offset: -4px;
				}
			}
		}

		.choice {
			display: flex;
			width: 100%;
			background-color: @whiteish;

			.bookmark {
				margin: 10px;
				background-color: @grey-light;
				// background: @choice-color-1; // The same as choice #0
			}

			.content-container {
				display: flex;
				align-self: stretch;
				flex: 1 1 auto;
				padding: 10px 10px 13px 10px;

				.content {
					margin: 0 auto;
				}
			}

			// choice-INDEX (0 indexed)
			// &.choice-1 .bookmark {
			// 	background: @choice-color-2;
			// }

			// &.choice-2 .bookmark {
			// 	background: @choice-color-3;
			// }

			// &.choice-3 .bookmark {
			// 	background: @choice-color-4;
			// }

			// &.choice-4 .bookmark {
			// 	background: @choice-color-5;
			// }

			// &.choice-5 .bookmark {
			// 	background: @choice-color-6;
			// }

			// &.choice-6 .bookmark {
			// 	background: @choice-color-7;
			// }

			.send-chat-message {
				margin: 0;
				text-align: center;
			}
		}
	}
</style>
